import { BaseComponent, WmsMessageComponent } from '@wms/components';
import { Component, EventEmitter, Inject, inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { WmsDialogComponent, WmsDialogHeaderComponent, WmsDialogBodyComponent, WmsDialogFooterComponent } from '@wms/components';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { DialogService } from '@wms/app/services/dialog/dialog.service';
import { SwaggerUiComponent } from '../swagger-ui/swagger-ui.component';
import { WebserviceService, ApisService,ProjectService, NotificationService } from '@wms/services';
import { cloneDeep, forEach, get, isObject } from 'lodash-es';
import { RouterModule, Router } from '@angular/router';
import { replace } from '@wm/core';
import {
  IWMSStandaloneEditorConstructionOptions,
  WMSEditorComponent,
} from '../../../components/wms-editor/wms-editor.component';
import { ImportApiService } from '@wms/app/services/import-api/import-api.service';
import { RestImportUiComponent } from '../rest-import-ui/rest-import-ui.component';
import { WmsWorkspaceManagerService } from "@wms/workspace";
import { ReimportApiConfirmationComponent } from '@wms/app/workspace/api-workspace/reimport-api-confirmation/reimport-api-confirmation.component';
import {MixpanelService} from "@wms/app/services/mixpanel/mixpanel.service";
import {isNewVerGreaterThanCurrentVer} from "@wms/core";
import { WebsocketComponent } from '../websocket/websocket.component';
import {WebscoketService} from "@wms/app/webscoket.service";
@Component({
  standalone: true,
  selector: 'wms-import-api',
  templateUrl: './import-api.component.html',
  styleUrls: ['./import-api.component.less'],
  imports: [
    CommonModule,
    WmsDialogComponent,
    WmsDialogHeaderComponent,
    WmsDialogBodyComponent,
    WmsDialogFooterComponent,
    WmsMessageComponent,
    SwaggerUiComponent,
    RouterModule,
    FormsModule,
    ButtonsModule,
    WMSEditorComponent,
    RestImportUiComponent,
    ReimportApiConfirmationComponent,
    WebsocketComponent
  ]
})
export class ImportApiComponent extends BaseComponent implements OnInit {

  webService: any;
  toggleMessage: any;
  swaggerMessage: any;
  compatibilityMessage: any;
  disableBtn: boolean = false;
  baseURL = 'assets/images/apis/'
  hideMonacoEditor: boolean = true;
  restImportServiceName: string = '';
  reimportInProgress: boolean;
  requestBody: any;
  responseBody: any = '';
  settingsUploadData: any;
  restImportDomID: string = 'editMode';
  restImportViewMode: boolean = false;
  wizardSteps:any = []
  showDialog: 'importDialog' | 'APIBundle' | 'restImportModal' | 'WEBSOCKET' = 'importDialog';
  @Input() modalName: 'reImportApi' | 'ImportApi' = 'ImportApi';
  @Output() onModalClose: EventEmitter<any> = new EventEmitter<any>();
  @Output() refreshService = new EventEmitter<any>();
  @ViewChild('restImportUI') restImportComponentUI: RestImportUiComponent;
  @ViewChild('webSocketUI') webSocketComponentUI: WebsocketComponent;

  editorOptions: IWMSStandaloneEditorConstructionOptions = {
    value: this.responseBody,
    language: 'json',
    automaticLayout: true,
    wordWrap: 'on',
    wrappingIndent: 'indent',
  };
  appBaseMetaInfo: any;
  private wsManager: WmsWorkspaceManagerService;
  tagsCount: any;
  webSocketService:WebscoketService
  constructor(private dialogService: DialogService, public apiService: ApisService,  private router: Router, private mixpanelService: MixpanelService,
    private importApiService: ImportApiService,@Inject("APP_BUILD_META_INFO") appBaseMetaInfo: any, private notificationService : NotificationService, ) {
    super();
    this.appBaseMetaInfo = appBaseMetaInfo;
    this.baseURL = this.appBaseMetaInfo.CDN_BASE_URL ? this.appBaseMetaInfo.CDN_BASE_URL + this.baseURL : this.baseURL;
    this.webService = inject(WebserviceService);
    this.wsManager = inject(WmsWorkspaceManagerService);
    this.webSocketService = inject(WebscoketService);
  }
  openDialogWithId(id: string): void {
    this.dialogService.open(id);
  }
  closeDialogWithId(id: string): void {
    this.dialogService.close(id);
    this.apiService.importDialogOpened = false;
  }
  handleImportClick() {
    const serviceName =
      this.restImportComponentUI.restImportData.restImportServiceName();
    if (serviceName.trim() !== '') {
      this.settingsUploadData =
        this.restImportComponentUI.restImportData.settingsUploadData();
      this.settingsUploadData['serviceId'] = serviceName;
      this.settingsUploadData['projectId'] = this.projectService.getProjectId();
      this.importApiService
        .importRest(this.settingsUploadData)
        .then(() => {
          this.dialogService.closeAllDialogs();
          this.apiService.importDialogOpened = false;
          this.router.navigate(['/apis/rest/' + `${serviceName}`]);
          this.refreshService.emit({'reload' : true});
          this.goBack();
        })
        .catch((error) => {
        });
    }
  }

  goBack(): void {
    this.showDialog = 'importDialog';
    this.resetWS();
    this.wsManager.setDirtyonWs(false)
  }

  closeAllDialogs(): void {
    this.dialogService.closeAllDialogs();
    this.apiService.importDialogOpened = false;
    if (this.webSocketService.ws.stepCount === 2) {
      this.apiService._generateAPINodeClick.next('');
    }
    if(this.webSocketService.ws.stepCount === 3){
      this.apiService.smdialogData == 2;
    }
    this.goBack();
    this.resetWS();
  }

  openService(id: 'importDialog' | 'APIBundle' | 'restImportModal' | 'WEBSOCKET'): void {
    if (id === 'restImportModal')
      setTimeout(() => {
        this.restImportComponentUI.initiateRestImportUI();
      }, 10);
    else if(id === 'WEBSOCKET'){
      this.wizardSteps = [{"name": "Test Connection", "label": this.locale.LABEL_TEST_CONNECTION}, {"name": "Configure WebSocket", "label": this.locale.LABEL_CONFIGURE_WEB_SOCKET}];
    }
    this.showDialog = id;
  }
  ngOnInit(): void {
    this.resetWS();
    this.apiService.smdialogData = 1;
    this.webSocketService.viewMode= 'create';
  }

  get reImportMsg(){
    return this.locale.MESSAGE_RE_IMPORT_APIS.split("${0}").join(this.apiService.activeApi?.serviceId);
  }

  resetWS() {
    this.showDialog = 'importDialog';
    this.toggleMessage = null;
    this.webSocketService.resetWS();
  }

  closeModal() {
    this.onModalClose.emit();
  }

  checkReimportedSwaggerCompatibility(reimportedSwaggerInfo: any): boolean {
    let currentSwaggerInfo = this.apiService.swaggerInfo.info;
    if(!currentSwaggerInfo.title || !reimportedSwaggerInfo.title || reimportedSwaggerInfo.title !== currentSwaggerInfo.title)
      return false;

    if(!currentSwaggerInfo.description || !reimportedSwaggerInfo.description || reimportedSwaggerInfo.description !== currentSwaggerInfo.description)
      return false;

    if(!currentSwaggerInfo.version || !reimportedSwaggerInfo.version || !isNewVerGreaterThanCurrentVer(currentSwaggerInfo.version, reimportedSwaggerInfo.version))
      return false;

    return true;
  }

  configureService(type: string) {
    if(type){
        this.webSocketComponentUI.configureWebSocketService()
    }else{
    let formData,
      connectionParams,
      urlInfo;
    this.disableBtn = true;
    if (this.webSocketService.ws.swaggerSource === 'URL' && !this.webSocketService.ws.swaggerSourceUrl) {
      this.toggleMessage = {
        'type': 'error',
        'caption': this.locale.MESSAGE_WEBSERVICE_IMPORT_FIELD_MISSING + this.locale.LABEL_SWAGGER_SOURCE
      };
      this.disableBtn = false;
      return;
    }
    else if (this.webSocketService.ws.swaggerSource === 'URL') {

      connectionParams = {
        'params': { 'URL': this.webSocketService.ws.swaggerSourceUrl },
        'urlParams': { 'projectID': this.projectService.getProjectId() },
        'data': {}
      };
      urlInfo = 'loadOpenAPIUrl';
    }
    else {
      // Angular does not bind file values so using native object to send files
      const inputEl = $("[name='wm-webservice-soap-source-file-input']") as any;
      if (!inputEl[0].files[0]) {
        this.toggleMessage = {
          'type': 'error',
          'caption': this.locale.MESSAGE_WEBSERVICE_IMPORT_FIELD_MISSING + this.locale.LABEL_SWAGGER_SOURCE
        };
        this.disableBtn = false;
        return;
      }
      formData = new FormData();
      if (inputEl[0].files[0]) {
        formData.append(this.webSocketService.ws.bindingsfileUploadInputName, inputEl[0].files[0]);
      }

      connectionParams = {
        'params': {},
        'urlParams': { 'projectID': this.projectService.getProjectId() },
        'data': formData
      };
      urlInfo = 'loadOpenAPI';
    }
    (this.webService[urlInfo](connectionParams) as Promise<any>).then((response) => {
      if (this.modalName === 'reImportApi') {
        if(!this.checkReimportedSwaggerCompatibility(response.swagger.info)) {
          this.compatibilityMessage = {
            show    : true,
            caption : this.locale.MESSAGE_WARN_PROPER_SWAGGER
          }
        } else {
          this.compatibilityMessage = {
            show : false
          }
        }
        this.disableBtn = true;
        this.swaggerMessage = { 'caption': this.locale.LABEL_DEPLOY_INSPECT_CHECKING_ISSUES, 'type': 'loading' };
        let connectionParamsCompare = {
          'params': {},
          'urlParams': { projectID : this.projectService.getProjectId(), serviceID: this.apiService.activeApi.serviceId },
          'data': ''
        }
        connectionParamsCompare.data = response.swagger;
        (this.webService.getSwaggerDiff(connectionParamsCompare) as Promise<any>).then((data) => {
          this.tagsCount = data;
          this.swaggerMessage = null;
          this.disableBtn = false;
        },
          (errorInfo: any) => {
            this.fetchErrorMessage(errorInfo);
            this.disableBtn = false;
          });
      }

      response.swagger.info['x-WM-SERVICE_TYPE'] = 'OpenAPIService';
      // increment the service setting step
      this.webSocketService.ws.stepCount += 1;
      this.apiService.smdialogData = this.webSocketService.ws.stepCount;
      this.webSocketService.ws.swaggerObject = cloneDeep(response.swagger);
      this.webSocketService.ws.customServiceName = response.serviceId;
      this.webSocketService.ws.originalSpecFileId = response.originalSpecFileId;

      let entities: any = [];
      let n: string;
      const methodTypes = ['get','put','post','delete', 'patch', 'head', 'options'];

      Object.keys(response.swagger.paths).forEach((item) => {
        Object.keys(response.swagger.paths[item]).forEach((innerItem) => {
          if(!isObject(response.swagger.paths[item][innerItem]) || methodTypes.indexOf(innerItem.toLowerCase()) < 0) {
                return;
            }
            let currentEntity: any = '';
            let ref: any = '';
            forEach(entities, function (entity) {
                if(entity.name === (response.swagger.paths[item][innerItem].tags && response.swagger.paths[item][innerItem].tags[0]) || (entity.name === 'Others' && (!response.swagger.paths[item][innerItem].tags || !response.swagger.paths[item][innerItem].tags[0]))) {
                    currentEntity = entity;
                }
            });
            response.swagger.paths[item][innerItem]['url'] = item;
            response.swagger.paths[item][innerItem]['methodType'] = innerItem;
            if(currentEntity) {
                currentEntity.paths.push(response.swagger.paths[item][innerItem]);
            } else {
                n = response.swagger.paths[item][innerItem].tags && response.swagger.paths[item][innerItem].tags[0] ? response.swagger.paths[item][innerItem].tags[0] : 'Others';
                if(n === 'Others') {
                    response.swagger.paths[item][innerItem]['x-WM-OPERATION_TYPE'] = '';
                }
                entities.push({name: n, paths: [response.swagger.paths[item][innerItem]], pathInfo: []});
            }
        });

        let tagObj = entities.find((item: any) => item.name === n);
        if (tagObj) {
          if (!tagObj['pathInfo'][0]) {
            tagObj['pathInfo'].push({});
          }
          tagObj['pathInfo'][0][item] = response.swagger.paths[item];
        }
      });
      this.webSocketService.ws.entities = entities;
      // For some swaggers, tags are empty. In such cases fill up tags for swagger plugin to work
      if (!this.webSocketService.ws.swaggerObject.tags.length) {
        forEach(entities, (entity) => {
          this.webSocketService.ws.swaggerObject.tags.push({'name': entity.name, 'description': ''});
        });
      }
      setTimeout(() => {
        this.setSwagger(this.webSocketService.ws.entities[0]);
      }, 0)

      this.setActiveEntity(this.webSocketService.ws.entities[0]);
      if (this.modalName !== 'reImportApi') {
      this.disableBtn = false;
      }
    }, (errorInfo) => {
      this.fetchErrorMessage(errorInfo);
      this.disableBtn = false;
    });
  }
  }
  reImporthasSwaggerName(evt:any){
    this.hasSwaggerName();
  }
  hasSwaggerName() {
    return this.webSocketService.ws.customServiceName ? false: true;
  }

  importService(type: string) {
    if(type === 'WEBSOCKET'){
      this.webSocketComponentUI.importService().then((serviceId) => {
        this.dialogService.closeAllDialogs();
        this.apiService.importDialogOpened = false;
        this.router.navigate(['/apis/websocket/' + `${serviceId}`]);
        this.refreshService.emit({'reload' : true});
        this.goBack();
      })
    }else{
    this.disableBtn = true;
    const serviceName = this.webSocketService.ws.serviceNameOption === 'auto' ? '' : this.webSocketService.ws.customServiceName;
    let temp;
    if(this.showDialog = 'APIBundle') {
      let endpointsCount = 0;
      this.webSocketService.ws.entities.forEach((entity: any) => {
        entity.pathInfo.forEach((path: any) => {
          endpointsCount += this.apiService.getEndpointsCount(path,"import");
        })
      });
      this.mixpanelService.track('open_api_bundle',{'service_id': serviceName, 'endpoints_count': endpointsCount});
    }

    this.webSocketService.ws.entities.forEach((entity: any) => {
      entity.paths.forEach((path: any) => {
        temp = cloneDeep(path);
        delete temp.methodType;
        delete temp.url;
        this.webSocketService.ws.swaggerObject.paths[path.url][path.methodType] = temp;
      })
    })

    const connectionParamsImport = {
      'params': {},
      'urlParams': { 'projectID': this.projectService.getProjectId() },
      'data': { 'serviceId': serviceName, originalSpecFileId: this.webSocketService.ws.originalSpecFileId, 'swagger': this.webSocketService.ws.swaggerObject }
    };
    this.uploadOpenAPIServiceCall(connectionParamsImport);
  }
  }

  uploadOpenAPIServiceCall(connectionParamsImport: any) {
    this.toggleMessage = {
      'type': 'loading',
      'caption': 'Importing'
    };
    (this.webService.uploadOpenAPI(connectionParamsImport) as Promise<any>).then((response) => {
      this.toggleMessage = null;
      this.dialogService.closeAllDialogs();
      this.apiService.importDialogOpened = false;
      this.wsManager.setDirtyonWs(false);
      this.resetWS();
      // this.dialogService.storeDialogRef = true;
      this.disableBtn = false;
      this.refreshService.emit({'reload': true, 'swagger': response.result});
       },(errorInfo) => {
        this.fetchErrorMessage(errorInfo);
        this.disableBtn = false;
    });
  }

  fetchErrorMessage(errorInfo: any){
    if (get(errorInfo, 'error.errors.error')) {
      let errMsg = "";
      const errorDetails = errorInfo.error.errors;
      /* If errors is not an array and contains error */
      if (errorDetails.error) {
          errorDetails.error.forEach((errorDetails: any, i: any) => {
              errMsg += this.parseError(errorDetails) + (i > 0 ? "\n" : "");
          });
      }
      if (errMsg.length) {
        this.toggleMessage = {
          'type': 'error',
          'caption': errMsg
        };
      }
    }
  }

  /* replace the parameters from service-error message*/
  parseError(errorDetails: any) {
    let errMsg;
    errMsg = errorDetails.message ? replace(errorDetails.message, errorDetails.parameters, true) : ((errorDetails.parameters && errorDetails.parameters[0]) || "");
    return errMsg;
  }

  setSwagger(entity: any) {
    this.toggleMessage = null;
    let entitySwagger = cloneDeep(this.webSocketService.ws.swaggerObject);
    entitySwagger.paths = entity.pathInfo[0];
    let tags = entitySwagger.tags.find((tag: any) => tag.name === entity.name);
    entitySwagger.tags = [tags];
    this.apiService._apiDocsSubject.next({ 'apiDocs': entitySwagger });
  }

  backButton() {
    this.wsManager.setDirtyonWs(false)
    if (this.webSocketService.ws.stepCount === 2) {
      this.apiService._generateAPINodeClick.next('');
    }
    this.webSocketService.ws.stepCount -= 1;
    this.apiService.smdialogData = this.webSocketService.ws.stepCount;
    this.webSocketService.ws.swaggerSource == 'URL' ? this.setActiveClass(false) : this.setActiveClass(true);
  }

  setActiveEntity(entity: any) {
    this.webSocketService.ws.activeEntity = entity;
    this.setSwagger(entity);
  }

  setActiveClass(addClass: Boolean) {
    this.toggleMessage = null;
    setTimeout(() => {
      const fileEl = $("[btnRadio='File']");
      if (addClass) {
        fileEl.addClass('active');
      } else {
        fileEl.removeClass('active');
      }
    }, 100);
  }

  reImportDialog(id: string) {
    this.webSocketService.ws.stepCount = 3;
    this.apiService.smdialogData = this.webSocketService.ws.stepCount;

  }

  closeReImportLoader(id: string): void {
    this.dialogService.close(id);
  }

  reimportServiceapiData(){
    this.reImportService();

  }

  statusApicall() {
      var Params = {
        params: {},
        'urlParams': { projectID: this.projectService.getProjectId(), serviceID: this.apiService.activeApi.serviceId },
        'data': ''
      },
        pollInterval = setInterval(() => {
          (this.webService.getStatusUpdate(Params) as Promise<any>).then((data) => {
            if (data === 'COMPLETED') {
                this.disableBtn         = false;
                this.reimportInProgress = false;
                clearInterval(pollInterval);
                this.apiService.reimportedServiceId = this.apiService.activeApi.serviceId;
                let goToAPIIssuesTab = this.tagsCount.effectedPaths !== 0;
                this.eventManager.emitopenAppIssuesTab({
                  reimportedServiceId : this.apiService.reimportedServiceId,
                  goToAPIIssuesTab    : goToAPIIssuesTab
                });
                this.eventManager.emitFetchAPIIssues({
                  reimportedServiceId : this.apiService.reimportedServiceId});
                this.closeAllDialogs();
              }
              else if(data === 'FAILED') {
                this.disableBtn         = false;
                this.reimportInProgress = false;
                this.notificationService.show('error', this.locale.MESSAGE_ERROR_TITLE, this.locale.MESSAGE_ERROR_FETCH_SERVICE.replace("${0}", this.apiService.activeApi.serviceId));
                clearInterval(pollInterval);
              }
          }, (error: any) => {
            clearInterval(pollInterval);
          });
        }, 2000);
  }
  reImportService() {

    this.disableBtn = true;
    const serviceName = this.apiService.activeApi.serviceId;
    let method;
    this.webSocketService.ws.activeEntity.paths.forEach((path: any) => {
      this.webSocketService.ws.swaggerObject.paths[path.url][path.methodType] = path;
      method = cloneDeep(this.webSocketService.ws.swaggerObject.paths[path.url][path.methodType]);
      delete method.methodType;
      delete method.url;
    });

    const paths = Object.keys(this.apiService.tagInfoOriginal.paths);
    paths.forEach((path: any) => {
      this.webSocketService.ws.swaggerObject.paths[path] = this.apiService.tagInfoOriginal.paths[path];
    });


    var connectionParams = {
      'params': {},
      'urlParams': { 'projectID': this.projectService.getProjectId() },
      'data': { 'serviceId': serviceName, originalSpecFileId: this.webSocketService.ws.originalSpecFileId, 'swagger': this.webSocketService.ws.swaggerObject }
    };
    this.reUploadOpenAPIServiceCall(connectionParams)
  }
  reUploadOpenAPIServiceCall(connectionParams: any) {
    this.reimportInProgress = true;
    (this.webService.reUploadOpenAPI(connectionParams) as Promise<any>).then((response) => {
      connectionParams.data = response;
      this.toggleMessage = null;
      this.apiService.fetchControllersInfo  = true;
      this.apiService.reimportRefreshData   = true;
      // this.dialogService.storeDialogRef = true;
      this.refreshService.emit({ 'reload': true, 'swagger': this.apiService.activeApi.serviceId });
      this.statusApicall();
    }, (errorInfo) => {
      this.fetchErrorMessage(errorInfo);
      this.disableBtn = false;
    });
  }

}
